import { useState } from 'react';

import { CasTable } from 'src/compass/shared/components';
import CasLink from 'src/compass/shared/components/CasLink/CasLink';
import getCasTableCellValue from 'src/compass/shared/components/CasTable/getCasTableCellValue';
import ICasRenderCellProps from 'src/compass/shared/components/CasTable/ICasRenderCellProps';

import { CasYesNoSelect } from 'src/compass/application';
import { IGeneralObjectType } from 'src/compass/site/util';

import GrowerDialog from '../shared/ClaimDetails/GrowerDialog';

export default function GrowersTab() {
  const [dialogRow, setDialogRow] = useState<IGeneralObjectType>({});
  const [reloadTable, setReloadTable] = useState<Date | null>(null);

  return (
    <>
      <CasTable
        entity="Sce/Grower"
        update={reloadTable}
        includeExport={false}
        columns={[
          {
            field: 'growerName',
            render: ({ row, column }: ICasRenderCellProps) => (
              <CasLink onClick={() => setDialogRow(row)}>
                {getCasTableCellValue({ row, column })}
              </CasLink>
            ),
          },
          { field: 'sharepointFolderName' },
        ]}
        filters={[
          {
            type: 'component',
            name: 'IsSharepointFolderEmpty',
            label: 'Sharepoint Folder is Empty',
            initialValue: true,
            includeAllOption: true,
            component: CasYesNoSelect,
          },
        ]}
      />
      {dialogRow.id && (
        <GrowerDialog
          id={dialogRow.id}
          insuredName={dialogRow.growerName}
          onUpdated={() => setReloadTable(new Date())}
          onClose={() => setDialogRow({})}
        />
      )}
    </>
  );
}
